export const schools = [
  {
    name: "Kalamazoo College",
    logo: "/images/Education/education-kzoo_logo.webp",
    idImage: "/images/Education/education-kzoo_id.webp",
    studentId: "269401",
    years: "2019 - 2023",
    degrees: [
      { type: "Bachelor's of Arts", major: "Mathematics" },
      { type: "Bachelor's of Arts", major: "Economics" }
    ],
    minors: ["Computer Science"]
  },
  {
    name: "Yonsei University",
    logo: "/images/Education/education-yonsei_logo.webp",
    idImage: "/images/Education/education-yonsei_id.webp",
    studentId: "760802",
    years: "Jan 2022 - Jun 2022",
    degrees: [
      { type: "Study Abroad Experience", major: "" }
    ],
    minors: []
  },
]; 